class Api {
	
	constructor() {
	}
	
	async sendMail(postBody, spinnerid) {
		return await this.postApi("POST", "/sendmail", postBody, spinnerid);
	}

	async sendSalesForceForm(postBody, spinnerid) {
		return await this.postApi("POST", "/salesforceform", postBody, spinnerid);
	}

	async getPosts(project, postType, spinnerid) {
		let postBody = {
		  "project": project,
		  "postType": postType,
		  "live": 1
		}
		
		return await this.postApi("POST", "/getcmsposts", postBody, spinnerid);
	}

	async makeToken(postBody, spinnerid) {
		return await this.postApi("POST", "/token", postBody, spinnerid);
	}


    getTokenCode() {
		const codePrefix = Math.floor(1000 + Math.random() * 9000);
		const date = new Date();
		const nowUTC = Date.UTC(
			date.getUTCFullYear(),
			date.getUTCMonth(),
			date.getUTCDate(),
			date.getUTCHours(),
			date.getUTCMinutes(),
			date.getUTCSeconds()
		);
  
		return `${codePrefix}-${Math.round(nowUTC / 60000).toString()}`;
	};

	
	async postApi(method, path, postBody, spinnerid) {
		
		if (spinnerid) {
			// show spinner
			document.getElementById(spinnerid).style.display = 'inline-block';
		}
		
		return fetch(`${process.env.API_ROOT}${path}`, {
			method: method,
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(postBody)
		})
        .then((response) => {
          return response.json();
        })
        .then((responseData) => {
          if (spinnerid) {
            // hide spinner
            document.getElementById(spinnerid).style.display = 'none';
          }

          return responseData;
        })
        .catch((error) => console.error(error));
	}
}

export default Api;